import base from './base';
import {i18n} from '@netx/core/i18n';
import {assetExpirationToDateString} from '@netx/core-asset-expiration/utils/assetExpirationToDateString';

import {AttributeTemplate} from '../types';

export const date = (
	value: any,
	{name, system}: Pick<AttributeTemplate, 'name' | 'system'>,
) => {
	// In all cases (currently), except one, we want `yyyy-mm-dd`
	// The dam will sometimes send us mm/dd/yyyy and we want to normalize this
	// except for `expirationDate` - which is a time and a time that we want to
	// show in a relative format
	if (system && name === 'expirationDate') {
		if (value) {
			value = `${i18n.t('i18n.expires')}: ${assetExpirationToDateString(
				value,
			)}`;
		}
		return value === 0 ? '' : value;
	}
	return base(value);
};

export default date;
